var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-transition-container"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.$store.state.keepAliveRoutes}},[_c('router-view',{staticClass:"global-transition-wrapper"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }